export default __webpack_public_path__ + "static/media/icon-check.4c1fefa0.svg";